export default {
  navigationBarTitleText: '全部产品'
};
